import ABTest from './ABTest.class';
import TestGroup from './TestGroup.class';

import {
  ABTestPaymentSystemGroupA,
  ABTestPaymentSystemGroupB,
} from './ABCodesModel';
import {
  AB_TEST_GOLD_PRICE_INCREASE_FOR_NEW_USER_ID,
  AB_TEST_GOLD_PRICE_INCREASE_FOR_OLD_USER_ID,
  AB_TEST_PRICE_DECREASE_FOR_NEW_USER_ID,
  AB_TEST_EPOCH_PAYMENT_SYSTEM_ID,
} from './ABTestConstants';

// eslint-disable-next-line import/prefer-default-export
// export const ABTestCommission = new ABTest( // Создаём новый тест
//   1, // Ставим ID, идентичное базе
//   new TestGroup().makeDefault(ABTest1GroupA), // Создаём A группу, в которой ничего не меняется
//   new TestGroup(2, ABTest1GroupB), // Создаём группу с ID, добавляем функцию на новый год, если нужно
// ).enable(); // Включаем АБ тест. Можно не комментировать кучу кода, а просто убрать или добавить тут enable

// eslint-disable-next-line import/prefer-default-export
export const ABTestPaymentSystem = new ABTest(
  9,
  new TestGroup().makeDefault(ABTestPaymentSystemGroupA),
  new TestGroup(2, ABTestPaymentSystemGroupB),
).enable();

export const ABTestPaypalPaymentSystem = new ABTest(
  14,
  new TestGroup().makeDefault(),
  new TestGroup(2),
).enable();

export const ABTestINXYWithdraw = new ABTest(
  19,
  new TestGroup().makeDefault(),
  new TestGroup(2),
).enable();

export const ABTestCheckoutPaymentSystem = new ABTest(
  25,
  new TestGroup().makeDefault(), // US Stripe / EU Ecommpay
  new TestGroup(2), // US Ecommpay / EU Ecommpay
  new TestGroup(3), // US Paypal cards / EU Checkout
  new TestGroup(4), // US Checkout / EU Checkout
).enable();

export const ABTestGoldPriceIncreaseForNewUsers = new ABTest(
  AB_TEST_GOLD_PRICE_INCREASE_FOR_NEW_USER_ID,
  new TestGroup().makeDefault(),
  new TestGroup(2),
).enable();

export const ABTestGoldPriceIncreaseForOldUsers = new ABTest(
  AB_TEST_GOLD_PRICE_INCREASE_FOR_OLD_USER_ID,
  new TestGroup().makeDefault(),
  new TestGroup(2),
).enable();

export const ABTestPriceDecreaseForNewUsers = new ABTest(
  AB_TEST_PRICE_DECREASE_FOR_NEW_USER_ID,
  new TestGroup().makeDefault(),
  new TestGroup(2),
).enable();

export const ABTestEpochPaymentSystem = new ABTest(
  AB_TEST_EPOCH_PAYMENT_SYSTEM_ID,
  new TestGroup().makeDefault(),
  new TestGroup(2),
).enable();
